import _slicedToArray from "/codebuild/output/src748241224/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { useDrawerAnimation, useFadeTransition } from "../../../../shared/animation";
import { Tag, promoCards, mainPromo, productCards, productLinks, productCategories } from "../../productLinks";
import { topLevelLinks } from "../../links";
import * as S from "./styles";
export var ShopDrawerContent = function ShopDrawerContent(_ref) {
  var e = _ref.active,
      t = _ref.onSubMenuOpen,
      a = _ref.onSubMenuClose;

  var _useState = useState(Tag.None),
      _useState2 = _slicedToArray(_useState, 2),
      r = _useState2[0],
      n = _useState2[1],
      o = useDrawerAnimation(e),
      l = useFadeTransition(r !== Tag.None && e),
      c = useFadeTransition(r);

  useEffect(function () {
    e || n(Tag.None);
  }, [e]), useEffect(function () {
    r === Tag.None ? a && a() : t && t();
  }, [r]);

  var s = function s(e, t) {
    return function () {
      return function (e, t) {
        return function () {
          n(e === t ? Tag.None : t);
        };
      }(e, t)();
    };
  },
      u = function u(e) {
    return function (_ref2) {
      var t = _ref2.tags;
      return t.includes(e);
    };
  },
      m = function m(e) {
    return productCards.filter(u(e));
  },
      i = function i(e) {
    return promoCards.filter(function (e) {
      return function (_ref3) {
        var t = _ref3.product;
        return t.tags.includes(e);
      };
    }(e));
  },
      p = function p(_ref4) {
    var e = _ref4.links,
        t = _ref4.cards,
        a = _ref4.promos;
    return React.createElement(React.Fragment, null, e.length ? React.createElement(S.SubMenuSectionWrapper, {
      key: "links"
    }, e.map(function (e) {
      return React.createElement(S.ProductLink, {
        key: e.slug,
        "data-testid": e.slug,
        href: e.url
      }, e.label);
    })) : null, t.length ? React.createElement(S.SubMenuSectionWrapper, {
      key: "cards"
    }, t.map(function (e) {
      return React.createElement(S.ProductCard, Object.assign({
        key: e.slug
      }, e));
    })) : null, a.length ? React.createElement(S.SubMenuSectionWrapper, {
      key: "promos"
    }, a.map(function (e) {
      return React.createElement(S.PromoCard, Object.assign({
        key: e.product.slug
      }, e));
    })) : null);
  };

  return React.createElement(React.Fragment, null, o(function (e, t) {
    return t ? React.createElement(S.DrawerPrimaryContent, {
      style: e,
      "data-testid": "desktop-menu-drawer-shop"
    }, productCategories.map(function (e) {
      return React.createElement(React.Fragment, {
        key: e.slug
      }, React.createElement(S.MenuButon, {
        active: r === e.slug,
        onClick: s(r, e.slug)
      }, e.displayName));
    }), React.createElement(S.ShopAllMenuButton, {
      href: topLevelLinks.shopAll.url
    }, topLevelLinks.shopAll.label), React.createElement(S.ProductPromoWrapper, null, React.createElement(S.SubMenuSectionWrapper, null, React.createElement(S.PromoCard, Object.assign({}, mainPromo))))) : null;
  }), l(function (e, t) {
    return t ? React.createElement(S.DrawerSecondaryContent, {
      style: e,
      active: r !== Tag.None
    }, c(function (e, t) {
      return t ? React.createElement(S.SubmenuContentWrapper, {
        style: e
      }, React.createElement(p, {
        key: "submenu-" + r,
        links: (a = r, productLinks.filter(u(a))),
        cards: m(r),
        promos: i(r)
      })) : null;
      var a;
    })) : null;
  }));
};